export const testimonials = [
  {
    id: 1,
    name: 'Carlos Eduardo Mendes',
    role: 'Diretor Comercial',
    company: 'Móveis Primavera',
    text: 'Trabalhamos com a Speed Courier há mais de 5 anos. A pontualidade e o cuidado com nossos móveis são impressionantes. Nunca tivemos uma entrega atrasada ou danificada. Recomendo de olhos fechados.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20middle%20aged%20Brazilian%20businessman%20in%20formal%20attire%2C%20warm%20smile%2C%20clean%20neutral%20background%2C%20soft%20studio%20lighting%2C%20high%20quality%20portrait&width=200&height=200&seq=avatar-1&orientation=squarish',
    rating: 5,
  },
  {
    id: 2,
    name: 'Fernanda Oliveira',
    role: 'Gerente de Operações',
    company: 'Distribuidora Norte Capixaba',
    text: 'O serviço de carros dedicados da Speed Courier revolucionou nossa logística. Conseguimos reduzir custos em 30% e aumentar a satisfação dos nossos clientes finais. A equipe é extremamente profissional.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Brazilian%20businesswoman%20with%20confident%20expression%2C%20modern%20office%20attire%2C%20clean%20neutral%20background%2C%20soft%20studio%20lighting%2C%20high%20quality%20portrait&width=200&height=200&seq=avatar-2&orientation=squarish',
    rating: 5,
  },
  {
    id: 3,
    name: 'Roberto Silva',
    role: 'Proprietário',
    company: 'Transportes Silva Ltda',
    text: 'Como transportadora parceira, o redespacho da Speed Courier é essencial para nossa operação. Eles entregam onde nós não conseguimos chegar, com a mesma qualidade e compromisso. Parceria de verdade.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20mature%20Brazilian%20male%20entrepreneur%20with%20friendly%20demeanor%2C%20business%20casual%20attire%2C%20clean%20neutral%20background%2C%20soft%20studio%20lighting%2C%20high%20quality%20portrait&width=200&height=200&seq=avatar-3&orientation=squarish',
    rating: 5,
  },
  {
    id: 4,
    name: 'Ana Paula Ribeiro',
    role: 'Coordenadora de Logística',
    company: 'Supermercados Capixaba',
    text: 'O rastreamento em tempo real é um diferencial enorme. Consigo informar meus clientes exatamente onde está a carga, o que aumenta muito a confiança. Speed Courier é sinônimo de confiabilidade.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Brazilian%20businesswoman%20with%20friendly%20smile%2C%20corporate%20attire%2C%20clean%20neutral%20background%2C%20soft%20studio%20lighting%2C%20high%20quality%20portrait&width=200&height=200&seq=avatar-4&orientation=squarish',
    rating: 5,
  },
];